// src/index.js — React-Einstieg: bindet Router & Tailwind-CSS ein

import React from "react";
import { createRoot } from "react-dom/client";
// import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./store";
import App from "./App";
import "./index.css";
import { debugLog, setDebugMode, clearDebugMode } from "./utils/debuglog";
import 'bootstrap/dist/css/bootstrap.min.css';

// const root = ReactDOM.createRoot(document.getElementById("root"));
const container = document.getElementById("root");
const root = createRoot(container);
window.debuglog = { debugLog, setDebugMode, clearDebugMode };

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
